import { types } from '../types/types';

const initialState = [];

export const providerReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.setProviders:
			return action.payload;

		case types.cleanProviders:
			return initialState;

		default:
			return state;
	}
};
